module.exports = __webpack_public_path__ + "img/opt_5.f64adde9.png";